import React, { useState, useEffect } from "react";
import { useMutation } from "@apollo/react-hooks";

import { GET_DOWNLOAD_ICON } from "./mutations";
import {
    DEFAULT_DOWNLOAD_TYPE,
    DEFAULT_DOWNLOAD_SIZE,
    DEFAULT_BACKGROUND_SHAPE,
    DEFAULT_COLOR,
    getIconFilename
} from "icons/helpers";

const useIconDownload = ({
    icon,
    downloadType = DEFAULT_DOWNLOAD_TYPE,
    downloadSize = DEFAULT_DOWNLOAD_SIZE,
    foregroundColor = DEFAULT_COLOR,
    backgroundShape = DEFAULT_BACKGROUND_SHAPE,
    backgroundShapeColor = DEFAULT_COLOR,
    backgroundShapeOpacity = 0.0,
    rotation = 0,
    flipX = false,
    flipY = false,
    client // optional - for legacy pages
}) => {
    const iconId = icon ? icon.id : null;

    const [isStarted, setIsStarted] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [hasFailed, setHasFailed] = useState(false);
    const [fetchDownload, { data }] = useMutation(GET_DOWNLOAD_ICON, {
        variables: {
            iconId,
            imageFormat: downloadType,
            exportSize: downloadSize,
            foregroundColor,
            // foregroundOpacity - TODO waiting for backend support
            backgroundShapeColor,
            backgroundShapeOpacity,
            backgroundShape,
            rotation,
            flipX,
            flipY
        },
        client
    });

    useEffect(() => {
        if (!!data && data.downloadIcon) {
            const { ok, errors, base64Stream } = data.downloadIcon;
            if (ok) {
                const contents = `data:application/octet-stream;base64,${base64Stream}`;
                const filename = getIconFilename({
                    icon,
                    type: downloadType,
                    color: foregroundColor
                });

                // The only way to download a base64 image with a customized filename
                // is to use an anchor-tag with the "download" attribute.
                const a = document.createElement("a");
                a.setAttribute("href", contents);
                a.setAttribute("download", filename);
                a.setAttribute("target", "_blank");
                a.click();
            } else if (errors) {
                setHasFailed(true);
            }

            setIsComplete(true);
        }
    }, [data]);

    const startDownload = () => {
        fetchDownload();
        setIsStarted(true);
        setIsComplete(false); // reset in case they're downloading again
        setHasFailed(false);
    };

    return {
        startDownload,
        isStarted,
        isComplete,
        hasFailed
    };
};

export default useIconDownload;
